export enum AIOnboardingType {
  GENERAL = 'dismissAiOnboarding',
  EDGELESS = 'dismissAiOnboardingEdgeless',
  LOCAL = 'dismissAiOnboardingLocal',
}
